import { oz } from '@weft/utils';
import { CreditPromotionConfigurationSchema, FreeTrialPromotionConfigurationSchema, PercentagePromotionConfigurationSchema } from './promotion-configuration-schemas';

export const PromotionConfigurationSchema = oz.union([
  CreditPromotionConfigurationSchema,
  FreeTrialPromotionConfigurationSchema,
  PercentagePromotionConfigurationSchema,
]);

export type PromotionConfiguration = oz.infer<typeof PromotionConfigurationSchema>;